import useCookieConsent from '@/hooks/useCookieConsent';
import { getCookie } from '@/utils/cookies';
import { useEffect, useRef } from 'react';
import { Movements } from '../enum/movements';
import { useGetMovement } from './useGetMovement';
export function useSyncedMovement(initialMovement) {
    var hasConsented = useCookieConsent().hasConsented;
    var _a = useGetMovement(initialMovement), availableMovements = _a.availableMovements, movementCache = _a.movementCache, selectedMovement = _a.selectedMovement, setSelectedMovement = _a.setSelectedMovement;
    var currentMovementRef = useRef(null);
    useEffect(function () {
        currentMovementRef.current = selectedMovement;
    }, [selectedMovement]);
    var updateMovement = function (movement) {
        currentMovementRef.current = movement;
        setSelectedMovement(movement);
        var movementSlug = movement.slug === Movements.Trending ? '' : movement.slug;
        window.history.pushState({ movementSlug: movementSlug }, '', "/".concat(movementSlug));
        if (movement.slug === Movements.Trending) {
            var existingCookie = getCookie('movement');
            if (existingCookie) {
                deleteCookieForMovement(existingCookie);
            }
        }
        else {
            if (hasConsented('functional'))
                createCookieForMovement(movement.slug, 60 * 60 * 24 * 30);
        }
    };
    useEffect(function () {
        if (availableMovements.length === 0)
            return;
        var handlePopState = function (event) {
            var _a, _b;
            var movementSlug = (_b = (_a = event.state) === null || _a === void 0 ? void 0 : _a.movementSlug) !== null && _b !== void 0 ? _b : window.location.pathname.replaceAll('/', '');
            var foundMovement = availableMovements.find(function (m) { return m.slug === movementSlug; });
            if (!foundMovement) {
                currentMovementRef.current = availableMovements[0];
                setSelectedMovement(availableMovements[0]);
            }
            else {
                currentMovementRef.current = foundMovement;
                setSelectedMovement(foundMovement);
            }
        };
        window.addEventListener('popstate', handlePopState);
        // Sync on initial load
        handlePopState({ state: window.history.state });
        return function () {
            window.removeEventListener('popstate', handlePopState);
        };
    }, [availableMovements]);
    var getCookieStringForMovement = function (movement, maxAge) {
        if (maxAge === void 0) { maxAge = 0; }
        return "movement=".concat(movement, "; max-age=").concat(maxAge, "; path=/");
    };
    var createCookieForMovement = function (movement, maxAge) {
        document.cookie = getCookieStringForMovement(movement, maxAge);
    };
    var deleteCookieForMovement = function (movement) {
        document.cookie = getCookieStringForMovement(movement);
    };
    return { availableMovements: availableMovements, movementCache: movementCache, selectedMovement: currentMovementRef.current, updateMovement: updateMovement };
}
